module.exports = __webpack_public_path__ + "img/nedir-02.9bc1a42a.svg";